module.exports = __webpack_public_path__ + "static/Code snippet-e315db127e37f2b89742deb8413bf33f.svg";